// extracted by mini-css-extract-plugin
module.exports = {"logoContainer":"DownLoadLogoCard_logoContainer__cK4jL","imageBox":"DownLoadLogoCard_imageBox__HrXCv","image":"DownLoadLogoCard_image__e8xpF"};